<template>
  <div id ="expenses">
    <v-container grid-list-md>
      <v-toolbar color="white" >
        <h2>Lotes</h2>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-container>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
           <v-data-table
            :items="batches"
            :expand="true"
            item-key="id"
            hide-actions
            hide-headers
          >
            <template v-slot:items="props">
              <tr @click="props.expanded = !props.expanded">
                <td>Lote #{{ props.item.id }}</td>
              </tr>
            </template>
            <template v-slot:expand="props">
              <v-data-table
                :items="props.item.routes"
                item-key="id"
                hide-actions
                hide-headers
              >
                <template v-slot:items="props2">
                  <tr @click="captureExpenses(props2.item)">
                    <td>{{props2.item.real_date | date }} </td>
                    <td>{{props2.item.description }} </td>
                    <td>{{props2.item.user}} </td>
                  </tr>
                </template>
              </v-data-table>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>

import { retrieveBatches } from '../services/batch';

export default {

  data() {
    return {
      batches: [],

    };
  },
  methods: {
    captureExpenses(element) {
      alert(JSON.stringify(element));
    },
  },
  async mounted() {
    try {
      const result = await retrieveBatches();
      this.batches = result.data;
    } catch (error) {
      this.$emit('error', error);
    }
  },
};
</script>
